import * as z from 'zod/v4';

import { dateTimeSchema } from '../frameworks/entry.js';
import { activatedDrawIdSchema } from './activatedDrawId.js';

const activatedDrawSchema = z
  .object({
    GroupId: z.number(),
    GroupName: z.string(),
    ContainerId: z.number(),
    ActivatedDrawId: activatedDrawIdSchema,
    SharePrice: z.string(),
    Balance: z.string(),
    RegClose: dateTimeSchema,
    BuyinCloseTime: dateTimeSchema,
  })
  .transform(({ ActivatedDrawId, Balance, ...draw }) => ({
    ...draw,
    activatedDrawId: ActivatedDrawId,
    balance: Number.parseInt(Balance, 10),
  }));

export type ActivatedDraw = z.infer<typeof activatedDrawSchema>;

export const marketplaceBalanceResponse = z.object({
  activatedDraws: z.array(activatedDrawSchema),
});

export type MarketplaceBalance = z.infer<typeof marketplaceBalanceResponse>;
